// extracted by mini-css-extract-plugin
module.exports = {"block":"HighSchoolNewsModule_block__VkEM0","btnViewAll":"HighSchoolNewsModule_btnViewAll__Z7yq2","list":"HighSchoolNewsModule_list__ZDDIv"};